module.exports = __webpack_public_path__ + "static/media/visa-card.d62f3616.png";